import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/actions/index';
import { useParams } from "react-router";
import Projectunits from './Projectunits';
import ProjectCalculation from './ProjectCalculation';
import * as modalTypes from '../Modals/modalTypes';
import PsSearch from '../UI/PsSearch';
import PsDropdown from '../UI/PsDropdown';
import useCustomTranslation from '../../hooks/useCustomTranslation';
import {Link } from "react-router-dom";
import { ROUTES } from '../../routes';
import { useTranslation } from 'react-i18next';
import ConsumptionTable from '../Shared/ConsumptionTable';
import BackgroundActive from '../../images/icon_revit.png';
import Navigation from './Navigation';
import Aux from '../../hoc/Aux';

const Project = (props) => {

  const dispatch = useDispatch();
  const ct = useCustomTranslation();
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  let project = {};
  let { projectId } = useParams();
  let projectunit = {project_id: projectId};

  const consumptionData = useSelector(state => {
    const currentProject = actions.getProject(state, projectId);
    return currentProject ? actions.getInventoryObjects(state, 'projectConsumptions', currentProject.project_consumptions) : [];
  });

  useEffect(() => {
    const initializeProject = async () => {
      try {
        await dispatch(actions.initProject(projectId));
        await dispatch(actions.calculateProjectConsumption(projectId));
      } catch (error) {
        console.error('Fehler beim Initialisieren des Projekts:', error);
      }
    };

    initializeProject();
  }, [dispatch, projectId]);

  const thisProject = useSelector(state => {
    return (projectId) => actions.getProject(state, projectId)
  });

  const loading = useSelector(state => state.inventory.loading_project );

  const showPdfModalHandler = () => {
    dispatch(actions.downloadProjectPdf(projectId, project.title));
  }

  const showDeleteProjectModalHandler = () => {
    const modalProps = {open: true, projectId: project.id};
    const modalType = modalTypes.MODAL_DELETE_PROJECT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showToggleActivateProjectModalHandler = () => {
    let modalType = (props.archived === true)? modalTypes.MODAL_REACTIVATE_PROJECT : modalTypes.MODAL_DEACTIVATE_PROJECT
    const modalProps = {open: true, projectId: projectId};
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showCreateProjectunitModalHandler = () => {
    const modalProps = {open: true, formObject: projectunit};
    const modalType = modalTypes.MODAL_CREATE_PROJECTUNIT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const titleToggleArchive = (project.archived === true)? ct('projectcard.dropdown.reactivate_project') : ct('projectcard.dropdown.archive_project')

  const dropDownItems = () => {
     let options = [];
      options.push({action: showPdfModalHandler, text: ct('projectcard.dropdown.create_project_pdf'), id: projectId + "pdf"});
      options.push({action: showToggleActivateProjectModalHandler, text: titleToggleArchive, id: projectId + "togglestatus"});
      if (project.role === "owner") { options.push({action: showDeleteProjectModalHandler, text: ct('projectcard.dropdown.delete_project'), id: projectId + "delete" })};
      options.push({action: actions.downloadAngebotskalkulationPdf(projectId), text: t('projectcard.dropdown.download_angebotskalkulation_pdf', "Angebots-PDF"), id: projectId + "download_angebotskalkulation_pdf" });
      return options;
  }

  const outBuilding = () => (project.building !== null && project.building !== "")? ", " + project.building : null

  const toS = (x) => (x !== undefined)? x : ""

  const outAddress = () => {
    let ret = [];
    if (toS(project.street) !== "") {
      ret.push(toS(project.street) + " " + toS(project.housenumber));
    }
    ret.push(toS(project.zipcode) + " " + toS(project.city));
    ret.push(t('countryname_' + project.countrycode) )
    return ret.join(", ");
  }

  const linkToRevitFile = () => window.open(t('link_to_bim_help_document_extern'), "_blank")

  if ( !loading || project !== {}) {
    project = thisProject(projectId) || {};

    return (


      <Aux>
        <div className="main-container">
          <div className="container">
            <div className="row justify-content-center mt-5">
              <div className="col-xl-11 col-lg-11">
                <div className="page-header">

                <h1 style={{fontSize: "1.0rem"}}>
                  <span id="backlink"><Link to={ROUTES.TO_PROJECTS}>{ ct('project.navi.link.my_projects') }</Link></span> <i className="material-icons" style={{margin: "-5px", verticalAlign: "middle"}}>keyboard_arrow_right</i> {project.title}
                  <div style={{float: "right"}}>
                    <PsDropdown items={dropDownItems()}>
                      <button className="btn btn-primary" type="button" style={{background: "#fff3df", color: "#6c757d", borderColor: "#ccc"}}>
                        { t('wizard.steps.product_solution.button_options') }
                        <i className="material-icons align-top" style={{marginRight: "-10px"}}>more_vert</i>
                      </button>
                    </PsDropdown>
                  </div>
                </h1>

                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-3 col-lg-3 mb-10">
                <Navigation activeItem="projectunits" projectId={projectId} />
              </div>

              <div className="col-xl-8 col-lg-8 mb-10">
                <div className="tab-content">

                  <div className="card">
                    <div className="card-body">
                      <h4>{project.title}{outBuilding()}</h4>
                      <p>{outAddress()}</p>
                    </div>
                  </div>

                  <div className="tab-pane fade show active" id="tasks" role="tabpanel" data-filter-list="card-list-body">
                    <div className="row content-list-head">
                      <div className="col-auto">
                        <h2>{ ct('project.link.create_new_projectunit') }</h2>
                        <button style={{width: "1.5rem", height: "1.5rem"}} className="btn btn-round" onClick={showCreateProjectunitModalHandler}>
                          <i className="material-icons">add</i>
                        </button>
                        <h2 style={{paddingLeft: "20px"}}>{ ct('project.link.revit_help_link') }</h2>
                        <button onClick={linkToRevitFile} className="btn btn-round" style={{borderRadius: "0%", margin: "7px 12px 0px 0px", paddingLeft: "4px", backgroundImage: `url(${BackgroundActive})`, backgroundRepeat: "no-repeat", backgroundColor: 'transparent'}}>
                        </button>
                      </div>
                      <PsSearch
                        onChange={(value) => setSearch(value)}
                        placeholder={ t('common.searchfield.label') }
                        />
                    </div>
                    <Projectunits
                      project={project}
                      filter={search}
                      />

                      <ProjectCalculation
                        projectId={projectId}
                        />
                      
                      <ConsumptionTable consumptionData={consumptionData} />

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Aux>




      )
   } else {
     return null;
   }

}

export default Project;



// WEBPACK FOOTER //
// ./src/components/Project/Project.js